/* eslint-disable no-console */

// Events
import { MODAL_CLOSE, MODAL_CLOSED, MODAL_OPEN, MOUNT_COMPONENTS } from 'events';
import { component } from 'picoapp';

import choozy from 'utils/choozy';
// Utils
import { clear, hide, show, stringToNode } from 'utils/node';
import { dispatch } from 'utils/theme';

// Constants
const MODAL_ID = 'qatc';

const createOptionPlaceholder = (content) =>
  `<div class='h-10 px-2 min-w-[40px] bg-grey-light text-link_xs uppercase text-transparent'>${content}</div>`;

export default component((node, ctx) => {
  const { loader, loaderFit, loaderSize, inner } = choozy(node);

  const shadowDOM = new DocumentFragment();
  const cache = {};

  shadowDOM.appendChild(loader);

  const fetchContent = async (handle) => {
    const url = `/products/${handle}?view=qatc-modal-content`;
    const options = {
      method: 'GET',
    };

    try {
      const response = await fetch(url, options);
      const text = await response.text();
      const html = stringToNode(text);

      return Promise.resolve(html);
    } catch {
      return Promise.reject();
    }
  };

  const updateLoader = (hasFit, allOptions) => {
    if (hasFit) {
      show(loaderFit);
    } else {
      hide(loaderFit);
    }

    loaderSize.forEach((el) => hide(el));

    allOptions.forEach((options, index) => {
      const sizeLoader = loaderSize[index];
      const sizeLoaderInner = sizeLoader.querySelector('[data-loader-size-inner]');

      sizeLoaderInner.innerHTML = options.map(createOptionPlaceholder).join('');

      show(loaderSize[index]);
    });
  };

  const render = async ({ productHandle, productHasFit, productOptionsAmount }) => {
    updateLoader(productHasFit, productOptionsAmount);

    clear(inner);

    inner.appendChild(loader);

    try {
      cache[productHandle] = cache[productHandle] || (await fetchContent(productHandle));
    } catch (err) {
      console.error(err);
      return;
    }

    shadowDOM.appendChild(loader);
    inner.appendChild(cache[productHandle].cloneNode(true));

    ctx.emit(MOUNT_COMPONENTS);
  };

  ctx.on(MODAL_CLOSED, (state, { id }) => {
    if (id !== MODAL_ID) return;

    const form = node.querySelector('[data-product-form]');
    const { formId, productId } = form.dataset;

    document.dispatchEvent(new CustomEvent(`${productId}:${formId}:unmount`));
  });

  ctx.on(MODAL_OPEN, (state, { id, props }) => {
    if (id !== MODAL_ID) return;

    render(props);

    dispatch('activate-a2c-overlay', {
      productHandle: props.productHandle,
    });
  });

  node.addEventListener('product:form:submit', () => {
    ctx.emit(MODAL_CLOSE, null, { id: 'qatc' });
  });
});
